import React, {Component} from 'react';

class Anime extends Component {
	
    render () {

        return (
            <div className={`anim anim--${this.props.type} anim--delay-${this.props.delay} anim--duration-${this.props.duration}`}>
            {this.props.children}
            </div>
        );
    }
}

export default Anime;


// WEBPACK FOOTER //
// ./src/components/Anime/Anime.js